import { IconType } from "react-icons";
import { MdOutlineConfirmationNumber } from "react-icons/md";
import { RxDashboard } from "react-icons/rx";
import { FaBook, FaMoneyBill, FaUser } from "react-icons/fa6";
import { VscGraph } from "react-icons/vsc";
import { PiBook } from "react-icons/pi";
import { FaUsers } from "react-icons/fa";
import { IoInvertMode } from "react-icons/io5";
import { IoIosBook } from "react-icons/io";
import { BiCategoryAlt } from "react-icons/bi";
import { moduleRoutes } from "./Config/moduleRoutes";
import { useAuth } from "./hooks/useAuth";
import { Module } from "./models/UserRole.model";
import { useEffect, useState } from "react";

type NavItemTypeWithoutChild = {
  label: string;
  path: string;
  icon: IconType;
  children?: never;
};

type NavItemTypeWithChild = {
  label: string;
  path?: never;
  icon: IconType;
  children?: {
    label: string;
    path: string;
    icon: IconType;
  }[];
};

export type NavItemType = NavItemTypeWithChild | NavItemTypeWithoutChild;

export const navigation: NavItemType[] = [
  {
    label: "Dashboard",
    icon: RxDashboard,
    path: "/dashboard",
  },
  {
    label: "Users",
    icon: RxDashboard,
    path: "/admin",
  },
  {
    label: "Order",
    icon: RxDashboard,
    path: "/offline-order",
  },
  {
    label: "Future Purchase",
    icon: RxDashboard,
    path: "/future-purchase",
  },
  {
    label: "Product Management",
    icon: RxDashboard,
    path: "/product-management",
  },
  {
    label: "Franchise",
    icon: RxDashboard,
    path: "/franchise",
  },
  {
    label: "Student",
    path: "/student",
    icon: RxDashboard,
  },
  {
    label: "Advance Payment",
    icon: RxDashboard,
    path: "/advance-payment",
  },
  // {
  //   label: "Payments",
  //   icon: RxDashboard,
  //   path: "/payments",
  // },
  {
    label: "Dues",
    icon: RxDashboard,
    path: "/dues",
  },
  {
    label: "Drawer",
    icon: RxDashboard,
    path: "/drawer",
  },
  {
    label: "Configuration",
    icon: MdOutlineConfirmationNumber,
    children: [
      {
        label: "Payment Mode",
        path: "/payment-mode",
        icon: FaMoneyBill,
      },

      {
        label: "User Role",
        path: "/user-role",
        icon: FaUser,
      },
      {
        label: "Course",
        path: "/course",
        icon: IoIosBook,
      },
      {
        label: "Book",
        path: "/book",
        icon: FaBook,
      },
      {
        label: "Expense Category",
        path: "/expense-category",
        icon: BiCategoryAlt,
      },
      {
        label: "Level",
        path: "/level",
        icon: VscGraph,
      },
      {
        label: "Subject",
        path: "/subject",
        icon: PiBook,
      },
      {
        label: "Faculty",
        path: "/faculty",
        icon: FaUsers,
      },
      {
        label: "Mode",
        path: "/mode",
        icon: IoInvertMode,
      },
      {
        label: "Course Type",
        path: "/course-type",
        icon: IoIosBook,
      },
      {
        label: "Attempt",
        path: "/attempt",
        icon: IoIosBook,
      },
    ],
  },
];

// src/config/navigation.ts
export const useNavigationConfig = (): NavItemType[] => {
  const { getAvailableModules, isLoading } = useAuth();
  const [filteredNavigation, setFilteredNavigation] = useState<NavItemType[]>(
    []
  );
  useEffect(() => {
    if (!isLoading) {
      const availableModules: Module[] = getAvailableModules();

      const filtered = navigation
        .map((navItem) => {
          // Direct route
          if (navItem.path) {
            const moduleId = moduleRoutes[navItem.path];
            const hasAccess = availableModules.some(
              (m) => m.moduleId === moduleId
            );
            return hasAccess ? navItem : null;
          }

          // With children
          if (navItem.children) {
            const allowedChildren = navItem.children.filter((child) => {
              const moduleId = moduleRoutes[child.path];
              return availableModules.some((m) => m.moduleId === moduleId);
            });

            if (allowedChildren.length > 0) {
              return { ...navItem, children: allowedChildren };
            }
          }

          return null;
        })
        .filter(Boolean) as NavItemType[];

      setFilteredNavigation(filtered);
    }
  }, [isLoading]);

  return isLoading ? [] : filteredNavigation;
};
